export const shuffle = () => (
  <path
    d="M18 2l4 4m0 0l-4 4m4-4h-4.333a7 7 0 00-6.462 4.308l-1.41 3.384A7 7 0 013.333 18H2m20 0h-4.333A6.998 6.998 0 0113 16.218M22 18l-4-4m4 4l-4 4M2 6h1.333c1.869 0 3.616.743 4.9 2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
